const FIX_TRADING_ERROR_CODES = new Set([
  'INTERNAL_ERROR',
  'ORDER_NOT_EXECUTED',
  'VALIDATION_FAILED_OUT_OF_MARKET_HOURS',
  'VALIDATION_FAILED_INSTRUMENT_OUT_OF_TRADING_HOURS',
  'VALIDATION_FAILED_NON_POSITIVE_PROSPECTIVE_BP',
  'VALIDATION_FAILED_MIN_ORDER_SIZE',
  'VALIDATION_FAILED_MIN_ORDER_SIZE_INCREMENT',
  'VALIDATION_FAILED_MAX_ORDER_SIZE',
  'VALIDATION_FAILED_POSITION_LIMIT',
  'VALIDATION_FAILED_ACCOUNT_TERMINATED',
  'VALIDATION_FAILED_ACCOUNT_EXPIRED',
  'VALIDATION_FAILED_LIQUIDATION_IS_IN_PROGRESS',
  'NO_LIQUIDITY',
  'MARKET_CONDITIONS_CHANGED',
  'PBASED_ORDER_WRONG_CLOSING_DIRECTION',
  'PBASED_ORDER_NOT_ENOUGH_WORKING_QUANTITY',
  'PBASED_MARKET_ORDER_REPLACE_NOT_ALLOWED',
  'PBASED_REPLACE_POSITION_QUANTITY_NOT_ALLOWED',
  'PBASED_NO_POSITION_FOR_CLOSE',
  'ORDER_UNEXPECTED',
  'ORDER_CANNOT_BE_ACTIVATED',
  'ORDER_TOO_LATE_TO_CANCEL',
  'ORDER_TOO_LATE_TO_REPLACE_CANCEL',
] as const)

export function getFixTradingErrorMessage(
  response: Record<string, unknown>,
  t: (key: string) => string,
  fallback: string
): string {
  const text = typeof response.Text === 'string' ? response.Text : ''
  const code = text.split(':')[0].trim()
  if (FIX_TRADING_ERROR_CODES.has(code as never)) {
    return t(`FixTrading.${code}`)
  }
  return fallback
}

type GenericExceptionMessage = {
  match: string
  key: string
}

const GENERIC_EXCEPTION_MESSAGES: GenericExceptionMessage[] = [
  { match: 'CloseOnly', key: 'FixTrading.TRADING_ACCOUNT_CLOSE_ONLY' },
  { match: 'Read-only', key: 'FixTrading.TRADING_ACCOUNT_READ_ONLY' },
  { match: 'Negative balance', key: 'FixTrading.ORDER_VALIDATION_NEGATIVE_BALANCE' },
  {
    match: 'Order rejected due to negative balance',
    key: 'FixTrading.ORDER_VALIDATION_NEGATIVE_BALANCE',
  },
  { match: 'No metrics data available', key: 'FixTrading.ORDER_VALIDATION_NO_METRICS_AVAILABLE' },
  { match: 'Not enough margin', key: 'FixTrading.ORDER_VALIDATION_NOT_ENOUGH_MARGIN' },
  { match: 'Negative free margin', key: 'FixTrading.ORDER_VALIDATION_NEGATIVE_MARGIN' },
  {
    match: 'Position cannot be closed due to insufficient margin. Close partially or add funds',
    key: 'FixTrading.ORDER_VALIDATION_CLOSE_INSUFFICIENT_MARGIN',
  },
]

export function getGenericExceptionMessage(
  response: Record<string, unknown>,
  t: (key: string) => string,
  fallback: string
): string {
  const message = typeof response.Message === 'string' ? response.Message : ''
  const matched = GENERIC_EXCEPTION_MESSAGES.find((entry) => message.includes(entry.match))
  return matched ? t(matched.key) : fallback
}
